import { useState, useEffect, useCallback } from 'react';
import { DEFAULT_PRESET_VIEWS } from '../config/presetViews';
import { loadPresetViews, savePresetViews } from '../utils/firestoreStorage';

export function usePresetViews(uid) {
  const [views, setViews] = useState(DEFAULT_PRESET_VIEWS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!uid) { setViews(DEFAULT_PRESET_VIEWS); setLoaded(true); return; }
    loadPresetViews(uid).then(saved => {
      if (saved) {
        // Merge: start from saved, add any new defaults the user hasn't seen yet
        const savedIds = new Set(saved.map(v => v.id));
        const newDefaults = DEFAULT_PRESET_VIEWS.filter(v => !savedIds.has(v.id));
        const maxOrder = saved.reduce((m, v) => Math.max(m, v.order ?? 0), 0);
        const merged = [
          ...saved,
          ...newDefaults.map((v, i) => ({ ...v, order: maxOrder + i + 1 })),
        ];
        setViews(merged);
      } else {
        setViews(DEFAULT_PRESET_VIEWS);
      }
      setLoaded(true);
    });
  }, [uid]);

  const updateViews = useCallback(async (next) => {
    setViews(next);
    await savePresetViews(uid, next);
  }, [uid]);

  const enabledViews = views
    .filter(v => v.enabled !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return { views, enabledViews, updateViews, loaded };
}
